var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.746,
    height: 15,
    viewBox: "0 0 11.746 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2595",
    "data-name": "Rectangle 2595",
    width: 11.746,
    height: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6258",
    "data-name": "Group 6258",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M1.825,11.9h9.921V0H1.587A1.589,1.589,0,0,0,0,1.587V13.413A1.589,1.589,0,0,0,1.587,15H11.746V13.016h-.794v1.27H1.825a1.19,1.19,0,1,1,0-2.381M1.746,2.54a.476.476,0,0,1,.952,0V10a.476.476,0,0,1-.952,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseIcon);
export default __webpack_public_path__ + "static/media/course_icon.5235a072328409a2cd22225005dcea6d.svg";
export { ForwardRef as ReactComponent };